// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FilterForIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FilterForIcon" ref={forwardedRef} {...props}>
      <path d="M13.75 9.3V14l-4.5 3V9.3L4 3h15zm-3 4.897 1.5-1v-4.44L15.797 4.5H7.203l3.547 4.257z" />
      <path d="M7.5 12.75H5v2.5H3.5v-2.5H1v-1.5h2.5v-2.5H5v2.5h2.5z" />
    </SvgIcon>
  );
});

/**
 * Subtract a specific unit of data from a wider data set.
 * @public
 */
export const FilterForIcon = /* @__PURE__ */ Object.assign(
  FilterForIconComponent,
  { displayName: 'FilterForIcon' },
);
